export default __webpack_public_path__ + "static/media/makino.5df9f5fb.png";